module.exports = __webpack_public_path__ + "img/99icon_white.f6417f6a.svg";